export default "__VITE_ASSET__C8PlFRr9__"